import React from "react";
import { Box, Container, Typography, useTheme, Link } from "@mui/material";
import { footerLinks } from "../data/footerLinks";

const Footer: React.FC = () => {
  const theme = useTheme();
  return (
    <Box
      component="footer"
      sx={{
        pb: 4,
        mt: 4,
        backgroundColor: theme.palette.background.default,
        color: theme.palette.primary.contrastText,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="body2"
          align="center"
          color="inherit"
          sx={{
            mb: 1,
            color: theme.palette.text.primary,
            fontFamily: theme.typography.fontFamily,
          }}
        >
          {" "}
          &copy; {new Date().getFullYear()} Hungerford Consulting. All rights
          reserved.{" "}
        </Typography>

        {/* Links mapeados desde los datos */}
        <Box sx={{ textAlign: "center" }}>
          {footerLinks.map(({ label, href, external }) => (
            <Link
              key={label}
              href={href}
              underline="hover"
              target={external ? "_blank" : undefined}
              rel={external ? "noopener noreferrer" : undefined}
              sx={{ mx: 1, color: theme.palette.text.primary }}
            >
              {label}
            </Link>
          ))}
        </Box>
      </Container>
    </Box>
  );
};
export default Footer;
